/* JOURNAL */

const genericJournalUrlBuilder = (slug, tagSlug) =>
  `/zhurnal/${slug ? `${slug}/` : ''}${tagSlug ? `?tag=${tagSlug}` : ''}`;

export const buildJournalListingUrl = (rubrics, rubric, tagSlug) => {
  const rubricOrDefault = rubric || rubrics[0];

  return genericJournalUrlBuilder(
    rubricOrDefault.id === rubrics[0].id ? null : rubricOrDefault.seo_slug,
    tagSlug,
  );
};

export const buildJournalItemUrl = (itemSlug, tagSlug) =>
  genericJournalUrlBuilder(itemSlug, tagSlug);

/* HOME */

export const buildStoVoteLink = companyID => `https://sto.avtobazar.ua/vote/${companyID}/`;



// WEBPACK FOOTER //
// ./src/shared/helpers/urlBuilder.js